export default {
  MAIN: 'MAIN',
  FORM: 'FORM',
  CONTRACT: 'CONTRACT',
  PUBLIC: 'PUBLIC',
};
